import React from "react";
import axios from "axios";
// components

import config from "../../config";

import CardTable from "components/Tables/CardTable.js";

export default function Farmers() {

    const url = `${config.baseUrl}${config.apiEndpoints.listFarmers}`;
    const [farmers, setFarmers] = React.useState([]);
    const [columns, setColumns] = React.useState([
        { label: "Farmer Name", key: "name", render: (value) => <b>{value}</b> },
        { label: "Phone", key: "phone", render: (value) => <span>{value}</span> },
        { label: "Address", key: "address", render: (value) => <span>{value}</span> }
    ]);

    React.useEffect(() => {
        axios.get(url)
            .then((response) => {
                setFarmers(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    return (
        <>
            <div className="flex flex-wrap mt-4">
                <div className="w-full mb-12 px-4">
                    <CardTable
                        color="light"
                        heading="Farmers"
                        route="/admin/farmers/create"
                        columns={columns}
                        data={farmers}
                    />
                </div>
            </div>
        </>
    );
}